import { render, staticRenderFns } from "./TouchpointStatisticsInfoHeader.vue?vue&type=template&id=17b4e401&scoped=true&"
import script from "./TouchpointStatisticsInfoHeader.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/touchpoint-statistics-info-header.scss?vue&type=style&index=0&id=17b4e401&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4e401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b4e401')) {
      api.createRecord('17b4e401', component.options)
    } else {
      api.reload('17b4e401', component.options)
    }
    module.hot.accept("./TouchpointStatisticsInfoHeader.vue?vue&type=template&id=17b4e401&scoped=true&", function () {
      api.rerender('17b4e401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatisticsInfoHeader.vue"
export default component.exports